<template>
  <van-tabbar v-model="type" @change="onChange" active-color="#d1ae52" inactive-color="#8F8F8F" style="border-top: 1px solid #3b3c3d; box-sizing: border-box; background: #0a0a0a; z-index: 200">
    <van-tabbar-item class="tabbar-home">
      <span>首页</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tabbar/tabbar_icon1_select.png' : '/static/image/tabbar/tabbar_icon1_nor.png'" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>优惠</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tabbar/tabbar_icon3_select.png' : '/static/image/tabbar/tabbar_icon3_nor.png'" />

      </template>
    </van-tabbar-item>

    <van-tabbar-item class="tabbar-deposit">
      <span>存款</span>
      <template #icon="props">
        <div class="deposit-icon-wrap">
          <img :src="props.active ? '/static/image/tabbar/tabbar_icon2_select.png' : '/static/image/tabbar/tabbar_icon2_nor.png'" />
          <span class="deposit-badge">送2%</span>
        </div>
      </template>
    </van-tabbar-item>

    <!-- <van-tabbar-item>
      <span class="middle-txt">存款</span>
      <template #icon="props">
        <div class="middle-box">
          <div class="middle">
            <img src="/static/image/tabbar/tabbar_icon2_nor.png" />
          </div>
          <div class="lignt"></div>
        </div>
      </template>
    </van-tabbar-item> -->

    <!--  <van-tabbar-item>
      <span>客服</span>
      <template #icon="props">
       <img :src="props.active ? '/static/image/tabbar_icon6_select.png' : '/static/image/tabbar_icon6_nor.png'" />

      </template>
    </van-tabbar-item>
   <van-tabbar-item>
      <span>赞助</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tabbar_icon4_select.png' : '/static/image/tabbar_icon4_nor.png'" />
      </template>
    </van-tabbar-item> -->
    <van-tabbar-item>
      <span>提现</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tabbar/tabbar_icon7_select.png' : '/static/image/tabbar/tabbar_icon7_nor.png'" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item class="tabbar-mine">
      <span>我的</span>
      <template #icon="props">
        <img :src="props.active ? '/static/image/tabbar/tabbar_icon5_select.png' : '/static/image/tabbar/tabbar_icon5_nor.png'" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
//
export default {
  name: 'Foot',
  data() {
    return { type: 0 };
  },
  methods: {
    onChange(type) {
      let that = this;
      if (type == 0) {
        that.$parent.goNav(`/`);
      }
      if (type == 1) {
        that.$parent.goNav(`/activity`);
      }
      if (type == 2) {
        // 打开存款弹窗（含在线存款），弹窗无独立页面，恢复当前页选中态
        that.$parent.goNav(`/recharge`);
        that.$nextTick(() => {
          that.changPath();
        });
      }
      if (type == 3) {
        that.$parent.goNav(`/withdraw`);
      }
      if (type == 4) {
        that.$parent.goNav(`/mine`);
      }
    },
    changPath() {
      let that = this;
      let path = this.$route.path;
      if (path == '/') {
        that.type = 0;
      }
      if (path == '/activity') {
        that.type = 1;
      }

      if (path == '/withdraw') {
        that.type = 3;
      }
      if (path == '/mine') {
        that.type = 4;
      }
      if (path == '/gamePage' || path == '/hongbao') {
        that.type = 5;
      }
    },
  },
  mounted() {},
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.changPath();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '../../../static/css/chunk-611499bd.2ebefcf0.css';
.van-tabbar-item__icon img {
  display: block;
  width: 0.65rem;
  height: 0.65rem;
}
.van-tabbar-item {
  font-size: 14px;
}
.van-tabbar {
  height: 68px;
}
.van-tabbar-item--active {
  background: #0a0a0a;
}
.tabbar-home {
  background-image: url('/static/image/tabbar/icon_btm_lt.avif');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center bottom;
}
.tabbar-mine {
  background-image: url('/static/image/tabbar/icon_btm_rt.avif');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center bottom;
}
.deposit-icon-wrap {
  position: relative;
  display: inline-block;
  .deposit-badge {
    position: absolute;
    top: -0.1rem;
    right: -0.5rem;
    background: #ea4e3d;
    color: #fff;
    font-size: 0.2rem;
    padding: 0.05rem 0.1rem;
    border-radius: 0.25rem;
    white-space: nowrap;
  }
}
.middle-txt{position: relative;left: 30%;bottom: -.4rem;}
.middl-box{position: relative;}
.middle{background-color: #27292c; background-image: url('/static/image/tabbar/icon_btm_cz_1.avif');background-size: cover; background-position: center;
width: 1.26rem;height:1.26rem;border-radius: 50%;display: flex;align-items: center;justify-content: center;
position: absolute;left: 50%;top: -.95rem;margin-left: -0.58rem;border: 7px solid #27292c;
  img{animation: _heartbeat_1rl6d_1 1s infinite;width: 1.16rem;height: 1.16rem;border-radius: 50%;margin-top: 0.01rem;}
}
.lignt{    
    width: .76rem;
    height: .76rem;
    position: absolute;
    top: -.55rem;
    left: -.15rem;
    border-radius: .76rem;
    overflow: hidden;
    pointer-events: none;}
.lignt:before {
    content: "";
    position: absolute;
    top: .3rem;
    left: .6rem;
    width: .4rem;
    height: .95rem;
    z-index: 3;
    background: linear-gradient(to right, transparent, rgba(255, 255, 255, .4) 20%, rgba(255, 255, 255, .7) 40%, rgba(255, 255, 255, .7) 60%, rgba(255, 255, 255, .4) 80%, transparent);
    animation: _scanLight_1ewtj_1 1.2s ease-in-out infinite;
}
@keyframes _heartbeat_1rl6d_1 {
  0% {
    transform: scale(1);
  }
  15% {
    transform: scale(1.1);
  }
  30% {
    transform: scale(1);
  }
  45% {
    transform: scale(1.1);
  }
  60% {
    transform: scale(1);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes _scanLight_1ewtj_1 {
  0% {
    transform: translate(-80%, -25%);rotate: 15deg;
  }
  50% {
    transform: translate(-305%, -25%);rotate: 15deg;
  }
  80% {
    transform: translate(-205%, -25%);rotate: 15deg;
  }
  100% {
    transform: translate(-105%, -20%);rotate: 15deg;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/libs/Foot.vue